import * as yup from 'yup';
import { EditAccountingParameterForm } from '../../types';

export const getSchema = (): yup.ObjectSchema<EditAccountingParameterForm> =>
  yup.object().shape({
    countryId: yup.string().required(),
    journalType: yup.string().required(),
    source: yup.string().required(),
    category: yup.string().required(),
    categoryAlias: yup.string().required(),
    frequency: yup.string().required(),
    details: yup
      .array()
      .of(
        yup.object().shape({
          journalSubtype: yup.string().required(),
          subtype_description: yup.string().optional().nullable(),
          tender_wh: yup.string().required(),
          account: yup.string().required(),
          subAccount: yup.string().required(),
          project: yup.string().optional().nullable(),
          segment7: yup.string().optional().nullable(),
        })
      )
      .required(),
  });
